import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvCastEditor.html?raw';
import "../EvBookingEditorTypes";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";



interface RedEntry extends VAM2types.EvCast {
    state: string,
    is_red_entry: boolean,
}

class EvCastEditor extends compose(_WidgetBaseSP) {
	templateString: any = template;
    performerInput: MdsLax<InstanceType<typeof HintBox>>;


    isRedEntry: MdsLax<InstanceType<typeof CheckBox>>;
    castRedInput_Name: MdsLax<InstanceType<typeof Edit>>;
    castRedInput_Role: MdsLax<InstanceType<typeof Edit>>;

    castInputContainer: HTMLElement;
    redEntryInputContainer: HTMLElement;
    addRedEntryButton: HTMLButtonElement;

    redEntry: RedEntry;

    private emitAddedEvent(value: any, source: "hintbox" | "redEntry"): void {

        if (value != null) {
            this.emit("added", value, [EvBookingEditor_ListNames.EvCast]);

            switch (source) {
                case "hintbox":
                    this.performerInput.setValue(null);
                    break;
                case "redEntry":
                    this.castRedInput_Name.setValue(null);
                    this.castRedInput_Role.setValue(null);
                    break;
            }
        }

    }
    private _onChangeIsRedEntry(isRed: boolean): void {

        this.UiModder.domClass.toggle(this.redEntryInputContainer, "w3-hide", isRed === false);
        this.UiModder.domClass.toggle(this.castInputContainer, "w3-hide", isRed === true);
    }

    private _onChangeRedInput(value: any): void {

        if (value != null) this.redEntry = {
            $Displayname: "",
            ID: null,
            Classname: VAMclassNames.ev_cast,
            is_red_entry: true,
            order: null,
            state: "new",
            c_cast_address: this.castRedInput_Name.getValue(),
            c_cast_perfomer: this.castRedInput_Role.getValue(),
            ref_performer: null
        };

        let readyCheck = this.castRedInput_Name.getValue() ||
            this.castRedInput_Role.getValue();
        //this.opusRedInput_Author.getValue() ||
        //this.opusRedInput_Duration.getValue() != null;

        this.UiModder.domClass.toggle(this.addRedEntryButton, "w3-disabled", !readyCheck);
    }

    private _onChangePerformerInput(): void {
        let value = this.performerInput.getValue();

        this.emitAddedEvent(value, "hintbox");

    //    if (value != null) {
    //        this.emit("added", value, [EvBookingEditor_ListNames.EvCast]);
    //        this.performerInput.setValue(null)
    //    }
    }

    private _onClickAddRedEntryButton(): void {

        this.emitAddedEvent(this.redEntry, "redEntry");
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.domNode.addEventListener('click', function (evt) {

            evt.stopPropagation();

        });
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCastEditor);